import {
  Stepper,
  Stack,
  Tooltip,
  Button,
  Text,
  Alert,
  List,
} from '@mantine/core';

import { AdminDetails, CompanyDetails } from './Steps';

import { useSignUpFormContext } from '../../../contexts/forms/SignUpFormContext';

import { BaseFormProps } from '../../../@types/global';

export default function SignUpForm({
  onSubmit,
  isSubmitting = false,
}: BaseFormProps) {
  const { activeStep, previousStep, nextStep, form } = useSignUpFormContext();

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Stepper
        active={activeStep}
        allowNextStepsSelect={false}
        size="xs"
        wrap={false}
      >
        <Stepper.Step label="Company Details">
          <Stack gap="xs">
            <CompanyDetails />
            <Button mt="md" fullWidth={false} onClick={nextStep}>
              Next
            </Button>
          </Stack>
        </Stepper.Step>
        <Stepper.Step label="Admin Details">
          <Stack gap="xs">
            <AdminDetails disableFields={isSubmitting} />
            <Stack align="center" mt="md">
              <Tooltip
                multiline
                withArrow
                w={250}
                color="red"
                offset={10}
                arrowSize={6}
                label={
                  <>
                    <strong>Important: </strong>
                    This account will be considered the main admin account of
                    your company and will have control over all modules inside
                    the Kakitangan system.
                  </>
                }
              >
                <Button type="submit" loading={isSubmitting} w={200}>
                  Sign Up
                </Button>
              </Tooltip>
              <Button
                variant="subtle"
                onClick={previousStep}
                disabled={isSubmitting}
                w={200}
              >
                Back
              </Button>
            </Stack>
          </Stack>
        </Stepper.Step>
        <Stepper.Completed>
          <Alert color="green" title="Happy to have you on board!">
            <Stack>
              <Text component="span">
                Congratulations on taking the first step in supercharging your
                HR and Payroll processes with Kakitangan.com.
              </Text>
              <Text component="span">
                You will be receiving two emails from us shortly:
              </Text>
              <List type="ordered">
                <List.Item>Email address verification</List.Item>
                <List.Item>Instructions on how to use our platform</List.Item>
              </List>
              <Text component="span">
                Please verify your email before trying to log in. See you in the
                dashboard!
              </Text>
            </Stack>
          </Alert>
        </Stepper.Completed>
      </Stepper>
    </form>
  );
}
